export default __webpack_public_path__ + "./fonts/add.9a06f663.svg";